// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"70":"4b7f9e40","741":"90b570a0"}[chunkId] + ".chunk.css";
};